import { useParams } from 'react-router-dom'

const TableError = () => {
  const { accountId } = useParams()
  return (
    <div className="error_wrap" style={{ margin: '70px 0 50px' }}>
      <strong className="tit_error">페이지 오류 안내</strong>
      <p className="txt_error">
        일시적인 오류로 인해 서비스 연결이 되지 않습니다.
        <br />
        다시 시도해 주세요.
      </p>
      <div className="page_btn">
        <div className="inner_btn">
          <a href={`/${accountId}/dashboard`} className="btn_gb gb_bl">
            <span className="inner_g">홈으로 가기</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default TableError
